module.exports = __webpack_public_path__ + "img/Airbnb-Hybrid-Mobility-Kits.60d66c99.jpg";